import React from "react";
import { Button } from "../components/ui/button";
import { Heading } from "../components/ui/heading";
import { Text } from "../components/ui/text";
import { useNavigate } from "react-router";
import { useAuth } from "../context/AuthContext";

const Unauthorized = () => {
  const navigate = useNavigate();
  const { logout } = useAuth();

  const handleGoToLogin = async () => {
    try {
      await logout();
    } finally {
      navigate("/login", { replace: true });
    }
  };

  return (
    <div className="flex flex-col items-center justify-center min-h-screen p-4 text-center">
      <div className="max-w-md">
        <Heading className="mb-6">Access Denied</Heading>
        <Text className="mb-8">
          Sorry, you don't have permission to access this page. Please contact
          your administrator if you believe this is an error.
        </Text>
        <Button variant="outline" onClick={handleGoToLogin}>
          Go to Login
        </Button>
      </div>
    </div>
  );
};

export default Unauthorized;
